module.exports = __webpack_public_path__ + "static/media/password-generator.ed50826c.jpg";